import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';

// core components
import useStyles from './styles/cardBodyStyle';

interface Props {
  className?: string;
  children: React.ReactNode;
}

const CardBody: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  const { className, children, ...rest } = props;
  const cardBodyClasses = classNames({
    [classes.cardBody]: true,
    [className || '']: className !== undefined,
  });
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div className={cardBodyClasses} {...rest}>
      {children}
    </div>
  );
};

CardBody.defaultProps = {
  className: undefined,
};

export default CardBody;
